<template>
    <div v-if="isLoading" class="body-loader">
        <span class="loader"></span>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "LoadingPage",
    computed: {
        ...mapState(['isLoading'])
    },
}
</script>

<style lang="css">
.body-loader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    background: rgba(15, 23, 43, 0.35);
}

.loader {
    animation: rotate 1s infinite;
    height: 50px;
    width: 50px;
    top: 50%;
    left: 50%;
    position: absolute;
    margin: -25px 0 0 -25px;
}

.loader:before,
.loader:after {
    border-radius: 50%;
    content: "";
    display: block;
    height: 20px;
    width: 20px;
}

.loader:before {
    animation: ball1 1s infinite;
    background-color: #3597d4;
    box-shadow: 30px 0 0 #d1e6f4;
    margin-bottom: 10px;
}

.loader:after {
    animation: ball2 1s infinite;
    background-color: #d1e6f4;
    box-shadow: 30px 0 0 #3597d4;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg) scale(0.8)
    }

    50% {
        transform: rotate(360deg) scale(1.2)
    }

    100% {
        transform: rotate(720deg) scale(0.8)
    }
}

@keyframes ball1 {
    0% {
        box-shadow: 30px 0 0 #d1e6f4;
    }

    50% {
        box-shadow: 0 0 0 #d1e6f4;
        margin-bottom: 0;
        transform: translate(15px, 15px);
    }

    100% {
        box-shadow: 30px 0 0 #d1e6f4;
        margin-bottom: 10px;
    }
}

@keyframes ball2 {
    0% {
        box-shadow: 30px 0 0 #3597d4;
    }

    50% {
        box-shadow: 0 0 0 #3597d4;
        margin-top: -20px;
        transform: translate(15px, 15px);
    }

    100% {
        box-shadow: 30px 0 0 #3597d4;
        margin-top: 0;
    }
}
</style>
